import _ from 'lodash';
import * as QuestionnaireApiModels from '@/typings/questionnaires-api-models';

type ThisFieldTemplate = {
  id: string;
  linkedFields: Array<Pick<QuestionnaireApiModels.LinkedField, 'fieldTemplateId' | 'linkedFieldTemplateId'>>
};
const isNonMasterLinkedList = (listField: ThisFieldTemplate): boolean => {
  if (listField?.linkedFields && listField.linkedFields.length > 0) {
    const linkedFieldFieldTemplateIds = _.uniq(listField.linkedFields.map((linkedField) => linkedField.fieldTemplateId));
    const linkedFieldLinkedFieldTemplateIds = _.uniq(listField.linkedFields.map((linkedField) => linkedField.linkedFieldTemplateId));

    const isLinkedList = linkedFieldFieldTemplateIds.includes(listField.id);
    const isMasterList = linkedFieldLinkedFieldTemplateIds.includes(listField.id);

    if (isLinkedList && !isMasterList) {
      return true;
    }

    return false;
  }

  return false;
};

export default isNonMasterLinkedList;